import styled from "styled-components";

import { ButtonLink } from "~/components/Button";
import Modal from "~/components/Modal";
import Spacer, { Axis } from "~/components/Spacer";

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 20px;
`;
const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
`;
const TitleText = styled.div`
  font-size: 18px;
  font-weight: 800;
`;
const MainText = styled.div`
  font-size: 14px;
  font-weight: 500;
`;
const BulletList = styled.ul`
  font-size: 14px;
  font-weight: 500;
  list-style-type: circle;
  margin-top: 15px;
  margin-left: 20px;
  line-height: 18px;
`;

type DDQModalNotCompletedProps = {
  onSubmit?: () => void;
  onClose: () => void;
};

export default function DDQModalNotCompleted({ onSubmit, onClose }: DDQModalNotCompletedProps) {
  const onSubmitClick = () => {
    if (onSubmit) {
      onSubmit();
    }
  };

  return (
    <>
      <Modal active onClose={onClose}>
        <Modal.Body
          styles={{
            display: "flex",
            flexDirection: "column",
            maxWidth: 540,
          }}
        >
          <TitleText>
            {`Before you're able to share, please complete more of your company profile:`}
            <BulletList>
              <li>Ownership, Regulator, & Licensing</li>
              <li>Travel Rule Data & Requirements</li>
              <li>Services</li>
              <li>Customer Due Diligence & KYC</li>
              <li>Data Protection</li>
            </BulletList>
          </TitleText>
          <Spacer axis={Axis.VERTICAL} size={10} />
          <MainContent>
            <MainText></MainText>
          </MainContent>
        </Modal.Body>
        <Modal.Footer>
          <SpaceBetween>
            <ButtonLink onClick={onClose}>Close</ButtonLink>
            <ButtonLink color="success" onClick={onSubmitClick}>
              Fill out more of your company profile
            </ButtonLink>
          </SpaceBetween>
        </Modal.Footer>
      </Modal>
    </>
  );
}
